export enum HsePolicies {
    can_approve_project_main = "can_approve_project_main",
    can_approve_project_limb = "can_approve_project_limb",
    contexts_superviser = "contexts_superviser",
    can_supervise_context_prefix = "can_supervise_context_",

    view_visual_research_ctx = "view_visual_research_ctx",
    view_opa = "view_opa",
    can_edit_place = "can_edit_place",

    view_project = "view_project",
    view_draft_project = "view_draft_project",

    view_book = "view_book",
    view_draft_book = "view_draft_book",
    move_to_draft_book = "move_to_draft_book",
    can_supervise_book = "can_supervise_book",

    can_view_games = "can_view_games",

    edit_project = "edit_project",
    edit_project_self = "edit_project",
    edit_draft_project = "edit_draft_project",    
    can_supervise_project = "can_supervise_project", //взять кураторство
    can_supervise_lms_project = "can_supervise_lms_project",
    can_clear_curators_lst_project = "can_clear_curators_lst_project",
    can_pdf_print_project = "can_pdf_print_project",
    move_edit_project = "move_edit_project",
    allow_send_project_to_competition = "allow_send_project_to_competition",
    can_view_statistic_project = "can_view_statistic_project",

    can_edit_project_by_tag_category_art = "can_edit_project_by_tag_category_3baf5ce908d84cc2a8ac6c2fcc5a9c45",
    can_edit_project_by_tag_category_contemporary_art = "can_edit_project_by_tag_category_12545e352cb24ab5985ecf9c084e47f6",
    can_edit_project_by_tag_category_prefix = "can_edit_project_by_tag_category_",

    tag_ordinal_prefix = "tag_ordinal_",
    tag_expert_prefix = "tag_expert_",
    tag_editor_prefix = "tag_editor_",
    is_jury_member = "is_jury_member",

    create_project = "create_project",
    create_supervisionable_project = "create_supervisionable_project",

    allowed_to_be_team_owner = "allowed_to_be_team_owner",
    allowed_push_project_to_artz = "allowed_push_project_to_artz",

    edit_project_defence = "edit_project_defence",
    edit_defence_book = "edit_defence_book",

    edit_defence_post_longread = "edit_defence_post_longread",

    create_book = "create_book",
    edit_book = "edit_book",
    edit_book_self = "edit_book_self",
    view_author_roles = "view_author_roles",
    edit_author_roles = "edit_author_roles",
    create_unit = "create_unit",
    edit_units_settings = "edit_units_settings",
    edit_unit_shops_settings = "edit_unit_shops_settings",
    edit_owned_unit_settings = "edit_owned_unit_settings",
    edit_unit_owned_shop_settings = "edit_unit_owned_shop_settings", 
    create_competitions = "create_competitions",
    moderate_competitions = "moderate_competitions",
    moderate_prime_showcase = "moderate_prime_showcase",
    moderate_limb_showcase = "moderate_limb_showcase",
    
    admin_unit_prefix = "admin_unit_",
    access_ui_units_admin = "access_ui_units_admin",
    access_ui_content_admin = "access_ui_content_admin",
    access_brief_competitions = "access_brief_competitions",
    access_competitions = "access_competitions",

    lms_admin = "lms_admin",
    lms_scores_report_editor = 'lms_scores_report_editor',
    lms_channel_admin = 'lms_channel_admin',
    lms_manager = 'lms_manager',

    like_value_10 = "like_value_10",
    like_value_15 = "like_value_15",
    like_value_25 = "like_value_25",
    like_value_30 = "like_value_30",
    like_value_35 = "like_value_35",
    like_value_50 = "like_value_50",    
    like_value_prefix = "like_value_",

    can_edit_designer_profile = "can_edit_designer_profile",
    role_permission_admin = "role_permission_admin",

    edit_legal_documents = "edit_legal_documents"
}export enum HsePolicies {
    can_approve_project_main = "can_approve_project_main",
    can_approve_project_limb = "can_approve_project_limb",
    contexts_superviser = "contexts_superviser",
    can_supervise_context_prefix = "can_supervise_context_",

    view_visual_research_ctx = "view_visual_research_ctx",
    view_opa = "view_opa",
    can_edit_place = "can_edit_place",

    view_project = "view_project",
    view_draft_project = "view_draft_project",

    view_book = "view_book",
    view_draft_book = "view_draft_book",
    move_to_draft_book = "move_to_draft_book",
    can_supervise_book = "can_supervise_book",

    can_view_games = "can_view_games",

    edit_project = "edit_project",
    edit_project_self = "edit_project",
    edit_draft_project = "edit_draft_project",    
    can_supervise_project = "can_supervise_project", //взять кураторство
    can_supervise_lms_project = "can_supervise_lms_project",
    can_clear_curators_lst_project = "can_clear_curators_lst_project",
    can_pdf_print_project = "can_pdf_print_project",
    move_edit_project = "move_edit_project",
    allow_send_project_to_competition = "allow_send_project_to_competition",
    can_view_statistic_project = "can_view_statistic_project",

    can_edit_project_by_tag_category_art = "can_edit_project_by_tag_category_3baf5ce908d84cc2a8ac6c2fcc5a9c45",
    can_edit_project_by_tag_category_contemporary_art = "can_edit_project_by_tag_category_12545e352cb24ab5985ecf9c084e47f6",
    can_edit_project_by_tag_category_prefix = "can_edit_project_by_tag_category_",

    tag_ordinal_prefix = "tag_ordinal_",
    tag_expert_prefix = "tag_expert_",
    tag_editor_prefix = "tag_editor_",
    is_jury_member = "is_jury_member",

    create_project = "create_project",
    create_supervisionable_project = "create_supervisionable_project",

    allowed_to_be_team_owner = "allowed_to_be_team_owner",
    allowed_push_project_to_artz = "allowed_push_project_to_artz",

    edit_project_defence = "edit_project_defence",
    edit_defence_book = "edit_defence_book",

    edit_defence_post_longread = "edit_defence_post_longread",

    create_book = "create_book",
    edit_book = "edit_book",
    edit_book_self = "edit_book_self",
    view_author_roles = "view_author_roles",
    edit_author_roles = "edit_author_roles",
    create_unit = "create_unit",
    edit_units_settings = "edit_units_settings",
    edit_unit_shops_settings = "edit_unit_shops_settings",
    edit_owned_unit_settings = "edit_owned_unit_settings",
    edit_unit_owned_shop_settings = "edit_unit_owned_shop_settings", 
    create_competitions = "create_competitions",
    moderate_competitions = "moderate_competitions",
    moderate_prime_showcase = "moderate_prime_showcase",
    moderate_limb_showcase = "moderate_limb_showcase",
    
    admin_unit_prefix = "admin_unit_",
    access_ui_units_admin = "access_ui_units_admin",
    access_ui_content_admin = "access_ui_content_admin",
    access_brief_competitions = "access_brief_competitions",
    access_competitions = "access_competitions",

    lms_admin = "lms_admin",
    lms_scores_report_editor = 'lms_scores_report_editor',
    lms_channel_admin = 'lms_channel_admin',
    lms_manager = 'lms_manager',

    like_value_10 = "like_value_10",
    like_value_15 = "like_value_15",
    like_value_25 = "like_value_25",
    like_value_30 = "like_value_30",
    like_value_35 = "like_value_35",
    like_value_50 = "like_value_50",    
    like_value_prefix = "like_value_",

    can_edit_designer_profile = "can_edit_designer_profile",
    role_permission_admin = "role_permission_admin",

    edit_legal_documents = "edit_legal_documents"
}